import React from 'react';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
import Drawer from '../Mobile/Drawer';
// import BlogHomeOne from './BlogHomeOne'; // Blog hidden for now
import FaqHomeOne from './FaqHomeOne';
import FeaturesHomeOne from './FeaturesHomeOne';
import FooterHomeOne from './FooterHomeOne';
import HeroHomeOne from './HeroHomeOne';
import HomeOneHeader from './HomeOneHeader';
import PricingHomeOne from './PricingHomeOne';
import ServicesHomeOne from './ServicesHomeOne';
// import TeamHomeOne from './TeamHomeOne'; // Team hidden for now
import TestimonialHomeOne from './TestimonialHomeOne';
import TrafficHomeOne from './TrafficHomeOne';

function HomeOne() {
    const [drawer, drawerAction] = useToggle(false);

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HomeOneHeader action={drawerAction.toggle} className="dd-red" />
            <HeroHomeOne className="dd-red" />
            <ServicesHomeOne />
            <FeaturesHomeOne />
            <TrafficHomeOne />
            <TestimonialHomeOne />
            {/* <TeamHomeOne /> Team hidden for now */}
            <PricingHomeOne />
            <FaqHomeOne />
            {/* <BlogHomeOne /> Blog hidden for now */}
            <FooterHomeOne />
            <BackToTop />
        </>
    );
}

export default HomeOne;
